import React from "react";
import BusinessTurn from "components/Tvendo/BusinessPartner/DataMaster/BusinessTurn/BusinessTurn.js";

export default function () {
  return <BusinessTurn />;
}
